var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_207",
    "data-name": "Grupo 207",
    transform: "translate(-522 -819.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(522 819.5)",
    fill: "#ee7c2c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(526 823.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.7a4f272cfd4e1faae8acbaff4ebfeeeb.svg";
export { ForwardRef as ReactComponent };